import { render, staticRenderFns } from "./SmsHistory.vue?vue&type=template&id=7fc0a9fa"
import script from "./SmsHistory.vue?vue&type=script&lang=js"
export * from "./SmsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports